<template>
  <div class="atom-switch--style" @click="$emit('click')">
    <span v-if="titleDirection === 'left'" class="atom-switch--title-left">
      {{ title }}
    </span>
    <b-form-checkbox
      name="check-button"
      :disabled="isDisable"
      :class="switchStyle"
      v-model="switchValue"
      switch
      inline
      @change="onValueChange"
    >
      <span v-if="isIcon" class="switch-icon-left">
        <feather-icon icon="CheckIcon" />
      </span>
      <span v-if="isIcon" class="switch-icon-right">
        <feather-icon icon="XIcon" />
      </span>
    </b-form-checkbox>
    <span v-if="titleDirection === 'right'" class="atom-switch--title-right">
      {{ title }}
    </span>
  </div>
</template>

<script>
import { BFormCheckbox, BCardText } from "bootstrap-vue"
export default {
  name: "AtomSwitch",
  components: {
    BFormCheckbox,
    BCardText,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    titleDirection: {
      type: String,
      required: false,
      default: "right",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
    isIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: [Boolean, null],
      required: false,
      default: false
    },
  },
  emits: ["click"],
  computed: {
    switchValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    switchStyle() {
      if (this.color === "secondary") {
        return "custom-control-secondary"
      } else if (this.color === "success") {
        return "custom-control-success"
      } else if (this.color === "danger") {
        return "custom-control-danger"
      } else if (this.color === "warning") {
        return "custom-control-warning"
      } else if (this.color === "info") {
        return "custom-control-info"
      } else if (this.color === "dark") {
        return "custom-control-dark"
      } else {
        return "custom-control-primary"
      }
    },
  },
  methods:{
    onValueChange(){
      this.$emit("change",this.switchValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-control-label {
  padding-left: 0;
}

.custom-control-inline {
  margin-right: 0;
}

.atom-switch--style {
  display: inline;
  margin-right: 0.5rem;
  margin-left: 0.3rem;
}

.atom-switch--title-left {
  position: relative;
  top: -3px;
  left: -5px;
}

.atom-switch--title-right {
  position: relative;
  top: -3px;
  left: -3px;
}
</style>
